import { render, staticRenderFns } from "./SaveSignosVitales.vue?vue&type=template&id=f2584842"
import script from "./SaveSignosVitales.vue?vue&type=script&lang=js"
export * from "./SaveSignosVitales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports